/**
 * One flat shape for a contact row.
 *
 * Like `accounts`, this is a real, fully-built module — no legacy flat fixture
 * to reconcile, just the API's own nested shape (`account.name`, `owner.full_name`,
 * `dates.birthday`) read directly.
 */

/** crm.contact.buying_role CHECK, § 10's influence map, → pill tone. */
export const ROLE_TONE = {
  'Economic buyer': 'rose',
  Champion: 'emerald',
  'Technical DM': 'sky',
  Buyer: 'violet',
  Influencer: 'violet',
  Gatekeeper: 'amber',
  Blocker: 'neutral',
  'End user': 'neutral',
};

export const INFLUENCE_TONE = { High: 'rose', Medium: 'amber', Low: 'neutral' };

const CHANNEL_ICON = {
  Email: 'envelope', Phone: 'telephone', WhatsApp: 'whatsapp',
  Teams: 'microsoft-teams', LinkedIn: 'linkedin', 'In person': 'person-check',
};
export function channelIcon(channel) {
  return CHANNEL_ICON[channel] ?? 'chat-dots';
}

const LOGO_COLORS = ['#6366f1', '#0ea5e9', '#10b981', '#8b5cf6', '#f59e0b', '#14b8a6', '#f43f5e', '#d946ef'];

/** A stable colour from the contact's own id, matching `accountShape.logoColor`. */
export function avatarColor(id) {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return LOGO_COLORS[hash % LOGO_COLORS.length];
}

/**
 * An API contact as the flat row the views render.
 * @param {object} contact
 */
export function toRow(contact) {
  return {
    id: contact.id,
    contactNo: contact.contact_no,
    fullName: contact.full_name,
    firstName: contact.first_name,
    lastName: contact.last_name,
    salutation: contact.salutation,
    jobTitle: contact.job_title,
    department: contact.department,
    account: contact.account,
    reportsTo: contact.reports_to,
    email: contact.email,
    secondaryEmail: contact.secondary_email,
    phone: contact.phone,
    mobile: contact.mobile,
    whatsapp: contact.whatsapp,
    linkedinUrl: contact.linkedin_url,
    preferredChannel: contact.preferred_channel,
    buyingRole: contact.buying_role,
    influence: contact.influence,
    sentiment: contact.sentiment,
    isPrimary: contact.is_primary,
    birthday: contact.dates?.birthday ?? null,
    joinedCompanyOn: contact.dates?.joined_company_on ?? null,
    customerSince: contact.dates?.customer_since ?? null,
    address: contact.address,
    timezone: contact.timezone,
    consent: contact.consent,
    photoUrl: contact.photo_url,
    owner: contact.owner,
    duplicateOfId: contact.duplicate_of_id,
    custom: contact.custom,
    lastActivityAt: contact.last_activity_at,
    createdAt: contact.created_at,
    updatedAt: contact.updated_at,
    deletedAt: contact.deleted_at,
    rowVersion: contact.row_version,
  };
}

/** `buying_role IN ('Economic buyer', 'Champion', 'Technical DM')` — the prototype's "Decision makers" quick chip. */
export const DECISION_MAKER_ROLES = ['Economic buyer', 'Champion', 'Technical DM'];
